import React, { useEffect, useState } from "react";

const SectionBanner = () => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBanners = async () => {
        try {
            const res = await fetch("https://api.welbeing.in/home/aboutbanner/");
            const data = await res.json();
            if (data.status === "success") setBanners(data.data);
            else throw new Error("Failed to fetch banners");
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBanners();
    }, []);

    if (loading) {
        return (
            <section className="ratio_asos mt-3">
                <div className="container-lg">
                    <div className="text-center py-4">
                        <span className="spinner-border" style={{ color: "#911077" }} role="status"></span>
                    </div>
                </div>
            </section>
        );
    }

    if (error || banners.length === 0) return null;

    // Take only first 6 banners
    const displayBanners = banners.slice(0, 4);

    return (
        <section className="ratio_asos py-3">
            <div className="container-lg">
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: "12px",
                    }}
                >
                    {displayBanners.map((banner) => (
                        <div
                            key={banner.id}
                            style={{
                                position: "relative",
                                width: "100%",
                                borderRadius: "12px",
                                overflow: "hidden",
                            }}
                        >
                            <img
                                src={`https://api.welbeing.in/uploads/section-banners/${banner.image}`}
                                alt={banner.heading || "Banner"}
                                style={{
                                    width: "100%",
                                    height: "200px",
                                    objectFit: "cover",
                                    display: "block",
                                }}
                                onError={(e) => (e.target.src = "customer_data/no_image.webp")}
                            />

                            {/* Gradient overlay */}
                            <div
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    background:
                                        "linear-gradient(to right, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)",
                                }}
                            />

                            {/* Text content */}
                            {(banner.heading || banner.description) && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "5%",
                                        transform: "translateY(-50%)",
                                        zIndex: 2,
                                        maxWidth: "80%",
                                    }}
                                >
                                    {banner.heading && (
                                        <h2
                                            style={{
                                                color: "#fff",
                                                fontSize: "clamp(14px, 1.8vw, 22px)",
                                                fontWeight: "700",
                                                lineHeight: "1.3",
                                                marginBottom: "6px",
                                                textShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                            }}
                                        >
                                            {banner.heading}
                                        </h2>
                                    )}

                                    {banner.description && (
                                        <p
                                            style={{
                                                color: "rgba(255,255,255,0.88)",
                                                fontSize: "clamp(11px, 1vw, 13px)",
                                                marginBottom: "12px",
                                                lineHeight: "1.5",
                                            }}
                                        >
                                            {banner.description}
                                        </p>
                                    )}

                                    {banner.sub_id && (
                                        <a
                                            href={`/products?id=${banner.sub_id}`}
                                            className="btn-solid"
                                            style={{ display: "inline-block" }}
                                        >
                                            Shop Now
                                        </a>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SectionBanner;
